import api from "../api";

export const getRecentVisits = async (patientId) => {
  try {
    const response = await api.get(`/patients/${patientId}/visits`, {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!(response.status === 200)) {
      throw new Error("Network response was not ok");
    }

    return await response.data;
  } catch (error) {
    throw error.message;
  }
};

export const createVisit = async (patientId, note, date, attachments = []) => {
  try {
    const formData = new FormData();
    formData.append("note", note);
    formData.append("date", date);

    // Add attachments to FormData
    attachments.forEach((file, index) => {
      formData.append(`attachments`, file);
    });

    const response = await api.post(`/patients/${patientId}/visits`, formData, {
      credentials: "include",
      headers: {
        "Content-Type": "multipart/form-data",
      } 
    });

    if (response.status !== 201) {
      throw new Error("Network response was not ok");
    }

    return await response.data;
  } catch (err) {
     if (err.response && err.response.status === 400) {
      throw new Error(err.response.data?.error || "Bad request");
    }
    throw new Error(err.message || "Something went wrong");
};
}

export const getVisit = async (patientId, visitId) => {
  try {
    const response = await api.get(`/patients/${patientId}/visits/${visitId}`, {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!(response.status === 200)) {
      throw new Error("Network response was not ok");
    }

    return await response.data;
  } catch (error) {
    throw error.message;
  }
};

export const downloadAttachment = async (
  patientId,
  visitId,
  attachmentId,
  filename
) => {
  try {
    const response = await api.get(
      `/patients/${patientId}/visits/${visitId}/attachments/${attachmentId}`,
      {
        credentials: "include",
        responseType: "blob", // Important for file downloads
      }
    );

    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }

    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    throw new Error(error.message);
  }
};
